import { render, staticRenderFns } from "./CGUCGV.vue?vue&type=template&id=1e7378f8&"
import script from "./CGUCGV.vue?vue&type=script&lang=js&"
export * from "./CGUCGV.vue?vue&type=script&lang=js&"
import style0 from "./CGUCGV.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports